export default {
  'Post exposure': 'rgb(182, 117, 1)',
  Prophylactic: 'RGB(208, 222, 255)',
}
